import type { HelpFile } from '../../types/help'
import { IdentityLifecycleTimelineTestIds } from '../../../testids/IdentityLifecycleTimelineTestIds'

export const identityLifecycleTimelineHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [IdentityLifecycleTimelineTestIds.lifecycleTimeline]:
      'Vertikale Zeitleiste der Identitäts-Lebenszyklusereignisse — neueste zuerst. Jede Zeile zeigt das Zustandspaar, die auslösende Quelle, den Akteur, den Zeitstempel und die Begründung.',
    [IdentityLifecycleTimelineTestIds.lifecycleFiltersPanel]:
      'Zeitleiste nach auslösender Quelle und Datumsbereich filtern. Filter sind standardmäßig eingeklappt — auf "Filter" klicken zum Ausklappen.',
    [IdentityLifecycleTimelineTestIds.lifecycleTimelineEmpty]:
      'Keine Lebenszyklusereignisse entsprechen den aktuellen Filtern. Über "Filter zurücksetzen" alle Filter aufheben oder neue Übergänge abwarten.',
    [IdentityLifecycleTimelineTestIds.lifecycleTimelineError]:
      'Die Zeitleiste konnte nicht geladen werden. Details im Fehlerprotokoll prüfen und erneut versuchen.',
    [IdentityLifecycleTimelineTestIds.lifecycleTimelineLoading]: null,
    [IdentityLifecycleTimelineTestIds.lifecycleTimelineRows]:
      'Identitäts-Lebenszyklus-Ereigniszeilen — jede Zeile verlinkt bei vorhandener Referenz auf den Auslöser (Job-Ausführung oder Zugriffsanfrage).',
    [IdentityLifecycleTimelineTestIds.lifecycleEventTriggerRefLink]:
      'Direktlink zum Auslöser dieser Zustandsänderung — öffnet die zugehörige Job-Ausführung oder Zugriffsanfrage.',
    [IdentityLifecycleTimelineTestIds.btnToggleLifecycleFilters]:
      'Filterpanel dieser Zeitleiste ein- oder ausblenden.',
    [IdentityLifecycleTimelineTestIds.btnClearLifecycleFilters]:
      'Alle Filter dieser Zeitleiste zurücksetzen.',
    [IdentityLifecycleTimelineTestIds.inputLifecycleFilterFrom]:
      'Untere Grenze des Datumsbereichs — Ereignisse mit einem changed_at davor werden ausgeblendet.',
    [IdentityLifecycleTimelineTestIds.inputLifecycleFilterTo]:
      'Obere Grenze des Datumsbereichs — Ereignisse mit einem changed_at danach werden ausgeblendet.',
  },
}
